export type SupportedLanguage = "en" | "es" | "fr" | "ar";

export interface LanguageInfo {
  code: SupportedLanguage;
  name: string;
  englishName: string;
  dir: "ltr" | "rtl";
}

export const SUPPORTED_LANGUAGES: LanguageInfo[] = [
  {
    code: "en",
    name: "English",
    englishName: "English",
    dir: "ltr",
  },
  {
    code: "es",
    name: "Español",
    englishName: "Spanish",
    dir: "ltr",
  },
  {
    code: "fr",
    name: "Français",
    englishName: "French",
    dir: "ltr",
  },
  {
    code: "ar",
    name: "العربية",
    englishName: "Arabic",
    dir: "rtl",
  },
];

export const DEFAULT_LANGUAGE: SupportedLanguage = "en";
export const LANGUAGE_STORAGE_KEY = "peerbots_preferred_language";
